import React from 'react'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as Strings from './strings'
import * as communitiesActions from '../../actions/Communities'

class SelectedCommunityDialog extends React.Component {
  getCommunitites() {
    const { data } = this.props
    const communities = []

    Object.keys(data.communities).forEach(key => {
      communities.push({
        id: key,
        name: data.communities[key].name
      })
    })

    return communities
  }

  render() {
    const { config } = this.props
    const communities = this.getCommunitites()

    return (
      <Dialog
        onClose={() => this.props.hideSelectCommunityModal()}
        aria-labelledby={'simple-dialog-title'}
        open={config.selectCommunityModal.show}
      >
        <DialogTitle id={'simple-dialog-title'}>
          {Strings.default.SELECT_HOUSE}
        </DialogTitle>
        <div>
          <List>
            {communities.map(community => (
              <ListItem
                button
                onClick={() => {
                  this.props.setSelectedCommunity(community.id)
                  this.props.hideSelectCommunityModal()
                }}
                key={community.id}
              >
                <ListItemText>
                  <p>{community.name}</p>
                </ListItemText>
              </ListItem>
            ))}
          </List>
        </div>
      </Dialog>
    )
  }
}

function mapStateToProps({ data, config }) {
  return { data, config }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...communitiesActions }, dispatch)
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(SelectedCommunityDialog)



// WEBPACK FOOTER //
// ./src/components/containers/SelectCommunityDialog/index.js